<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="标题">
                <el-input v-model="formInline.giftTitle" placeholder="标题" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="findStorageCardInfo">查询</el-button>
                <el-button type="success" @click="addStorageCard">新增</el-button>
                <el-button type="success" @click="initData">初始化储值卡和礼品卡数据</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="storageCardList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="giftTitle" label="标题" width="180"></el-table-column>
            <el-table-column prop="giftCash" label="购买金额" width="110"></el-table-column>
            <el-table-column prop="freeCash" label="赠送金额" width="80"></el-table-column>
            <el-table-column prop="proName" label="商品名称" width="200"></el-table-column>
            <el-table-column prop="giftImg"  label="图片"  width="80">
                <template slot-scope="scope">
                    <img :src="scope.row.giftImg" width="70" height="70"/>
                </template>
            </el-table-column>
            <el-table-column :formatter="giftStateName" label="状态" width="120"></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <!-- <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button> -->
                    <el-button type="warning" size="mini" v-if="scope.row.giftState !=0"  @click="handleDelete(scope.row)">删除</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.giftState==1"  @click="handledCancel(scope.row)">停用</el-button>
                    <el-button type="success" size="mini" v-if="scope.row.giftState==2"  @click="handledStart(scope.row)">启用</el-button>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <!-- 新增储值卡window -->
        <el-dialog title="新增批次" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="120px" size="small ">
                <el-form-item label="标题" :required="true">
                    <el-input v-model="form.giftTitle" placeholder="标题" clearable @blur="inputBlur(form.giftTitle)"></el-input>
                </el-form-item>
                <el-form-item label="绑定商品" :required="true">
                    <el-select  v-model="form.proId" clearable @change="handleItemChange">
                        <el-option v-for="item in itemData"
                                   :key="item.proId"
                                   :label="item.proName"
                                   :value="`${item.proId},${item.proName}`">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买金额" >
                    <el-input v-model="form.giftCash" clearable  placeholder="购买金额" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="赠送金额" >
                    <el-input-number v-model="form.freeCash" :min="0" :max="10000" label="赠送金额"></el-input-number>
                </el-form-item>
                <el-form-item label="图片">
                    <uploadComponents v-model="form.giftImg" :urlType="2"></uploadComponents>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" placeholder="备注" v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddStorageCard(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findStorageCard,saveStorageCard,invalidStorageCard,getProductByProType,validationStorageInfo,getStorageCardByProId,getProduct,initData} from '@/api/api';
    import uploadComponents from '@/components/upload';
    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                itemData:[],
                storageCardList: [],// 储值卡信息
                form: {
                    giftTitle: '',
                    giftCash: '',
                    freeCash: '',
                    giftImg: '',
                    remark:'',
                    proId:''
                },
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
            }
        },
        //挂载时候执行
        mounted(){
            getProductByProType({proType:3}).then((res1) => {
                this.itemData = res1.data.value;
            });
            //初始化首页数据
            this.queryStorageCardInfo();
        },
        components:{
            uploadComponents
        },
        methods: {
            handleItemChange(data){
                //判断商品是否关联没删除的其他卡
                let _this = this;
                getStorageCardByProId({proId:data.split(',')[0]}).then((res) => {
                    if(res.data.status != 200){
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }else{
                        getProduct({proId:data.split(',')[0]}).then((res1) => {
                            _this.form.giftCash = res1.data.value.proPrice;
                        });
                    }
                });
            },

            queryStorageCardInfo(){
                findStorageCard(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.storageCardList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            //查询按钮
            findStorageCardInfo(){
                this.queryStorageCardInfo();
                this.formInline.currentPage = 1
            },
            //初始化卡按钮
            initData(){
                initData().then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryStorageCardInfo();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryStorageCardInfo();
            },

            //状态格式化
            giftStateName(row, column, cellValue) {
                if (row.giftState == 1) {
                    return "正常";
                } else if (row.giftState == 2) {
                    return "停用";
                }else {
                    return "删除";
                }
            },

            //新增事件
            addStorageCard() {
                this.form = {
                    giftTitle: '',
                    giftCash: '',
                    freeCash: '',
                    giftImg: '',
                    remark:''
                }
                this.dialogFormVisible = true;
            },
            //确定事件
            updateOrAddStorageCard(form) {
                if(form.giftTitle == "" || form.giftTitle == ''){
                    this.$message({
                        showClose: true,
                        message: '请填写标题',
                        type: 'error'
                    });
                    return false;
                }
                if(form.proId == null){
                    this.$message({
                        message:"请选择商品",
                        type:'error'
                    });
                    return;
                }else{
                    getStorageCardByProId({proId:form.proId.split(',')[0]}).then((res) => {
                        if(res.data.status != 200){  //不能绑定
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                           return;
                        }else{
                            if(form.giftCash < form.freeCash){
                                this.$message({
                                    message:"赠送金额不可大于购买金额",
                                    type:'error'
                                });
                                return;
                            }
                            saveStorageCard(form).then((res) => {
                                if (res.data.status == 200) {
                                    this.$message({
                                        showClose: true,
                                        message: '成功',
                                        type: 'success'
                                    });
                                    this.queryStorageCardInfo();
                                    this.dialogFormVisible = false;
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    });
                }
            },

            //删除事件
            handleDelete(row){
                this.$confirm('删除此储值卡, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    invalidStorageCard({cardId:row.id,cardState:0}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryStorageCardInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //停用事件
            handledCancel(row){
                this.$confirm('停用此储值卡, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    invalidStorageCard({cardId:row.id,cardState:2}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryStorageCardInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //启用事件
            handledStart(row){
                this.$confirm('启用此储值卡, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    invalidStorageCard({cardId:row.id,cardState:1}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryStorageCardInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //标题移除事件
            inputBlur(giftTitle){
                validationStorageInfo({giftTitle:giftTitle}).then((res) => {
                    if(res.data.status!=200){
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/storage/storageCard.vue